import { getFilters } from "../../common/config/filters";
import { valuedFilters } from "../../common/utils/filters";
import { DISCOVER, SEARCH } from "../constants/perspectives";
export function resolveNewPerspectiveFromTransitionFilters(newFilters) {
  return valuedFilters(newFilters).some((f, k) => getFilters().get(k) && !getFilters().getIn([k, 'discoverFilter'])) ? SEARCH : DISCOVER;
}